import React, { useEffect, useState } from 'react';
import './FeatureStyles.css';

const MFAAnimation = () => {
  const [phase, setPhase] = useState('entering'); // entering, generating, verifying, success
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [filledCount, setFilledCount] = useState(0);

  const digits = ['4', '8', '2', '7', '1', '5'];

  useEffect(() => {
    let timeout;

    if (phase === 'entering') {
      if (filledCount < 6) {
        timeout = setTimeout(() => {
          setCode(prev => {
            const next = [...prev];
            next[filledCount] = digits[filledCount];
            return next;
          });
          setFilledCount(prev => prev + 1);
        }, 250);
      } else {
        timeout = setTimeout(() => setPhase('verifying'), 500);
      }
    } else if (phase === 'verifying') {
      timeout = setTimeout(() => setPhase('success'), 1200);
    } else if (phase === 'success') {
      timeout = setTimeout(() => {
        setPhase('entering');
        setCode(['', '', '', '', '', '']);
        setFilledCount(0);
      }, 2500);
    }

    return () => clearTimeout(timeout);
  }, [phase, filledCount]);

  return (
    <div className="feature-animation mfa-totp">
      <div className="feature-panel">
        <div className="feature-panel-header">
          <div className="feature-panel-title">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0110 0v4" />
            </svg>
            MFA Verification
          </div>
        </div>

        <div className="feature-panel-body">
          <div className="mfa-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <div className="mfa-icon-wrapper">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="M9 12l2 2 4-4" />
              </svg>
            </div>

            <div className="mfa-label">Enter authenticator code</div>

            <div className="mfa-code-inputs" style={{ display: 'flex', flexDirection: 'row', gap: '6px', justifyContent: 'center' }}>
              {code.map((digit, idx) => (
                <div
                  key={idx}
                  className={`mfa-digit ${digit ? 'filled' : ''} ${idx === filledCount && phase === 'entering' ? 'active' : ''}`}
                  style={{ width: '32px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '6px', border: '1.5px solid', borderColor: digit ? '#db2777' : idx === filledCount && phase === 'entering' ? '#f472b6' : '#e5e7eb', background: digit ? '#fce7f3' : '#fff', fontSize: '18px', fontWeight: 600, color: '#db2777', transition: 'all 0.2s ease' }}
                >
                  {digit || ''}
                </div>
              ))}
            </div>

            {phase === 'verifying' && (
              <div className="mfa-status verifying">
                <div className="mfa-spinner"></div>
                <span>Verifying...</span>
              </div>
            )}

            {phase === 'success' && (
              <div className="mfa-status success" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                <span>Verified</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const MFAFeature = {
  icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  title: "Multi-Factor Authentication",
  description: "Test TOTP-based multi-factor authentication flows in your applications. Qate AI handles authenticator codes, time-based tokens, and MFA challenge screens automatically - so your tests can verify secure login flows end-to-end without manual intervention.",
  highlight: "Paid Plan",
  animation: <MFAAnimation />
};

export default MFAFeature;
